import React, { Component } from 'react';
import { Play, Shield, Eye, Clock, Users, CheckCircle, Star, ArrowRight, Phone, Mail, MapPin } from 'lucide-react';

class Privacy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

 

  render() {
   
const styles = {
      root: {
        '--primary-dark': '#010A1A',
        '--secondary-dark': '#002C58',
        '--text-primary': '#ffffff',
        '--text-secondary': '#94a3b8',
        '--box-dark-bg': '#1a2332',
        '--icons-color': '#155EEF',
        '--accent-cyan': '#06b6d4',
        '--accent-blue': '#3b82f6'
      }
    };
    return (
         <div className="min-vh-100" 
           style={{
             backgroundColor: 'var(--primary-dark)',
             color: 'var(--text-primary)',
             fontFamily: 'system-ui, -apple-system, sans-serif',
             ...styles.root
           }}>
        <section className="py-5 inner-pages">
    <div className="container">
      <div className="row">
        <div className="col-lg-12 mx-auto">
          {/* Header */}
          <div className="text-left mb-5">
            
            <h1 className="display-4 fw-bold mb-3" style={{ color: 'var(--text-primary)' }}>
              Privacy Policy
            </h1>
            {/* <p className="lead" style={{ color: 'var(--text-secondary)' }}>
              Last updated: June 22, 2025
            </p> */}
          </div>

          {/* Content */}
          <div className="p-4 rounded-3" style={{ backgroundColor: 'var(--box-dark-bg)' }}>
            
            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                1. Information We Collect
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3">
                  Sterling Surveillance Technologies Ltd collects information necessary to provide our remote security solutions, including:
                </p>
                <p className="mb-2"><strong>Personal Information:</strong></p>
                <ul className="mb-3">
                  <li>Contact details (name, email, phone, address)</li>
                  <li>Business information and property details</li>
                  <li>Emergency contact information</li>
                  <li>Payment and billing information</li>
                </ul>
                <p className="mb-2"><strong>Security Data:</strong></p>
                <ul className="mb-3">
                  <li>Video surveillance footage and recordings</li>
                  <li>Access control logs and entry records</li>
                  <li>Incident reports and security alerts</li>
                  <li>System usage and performance data</li>
                </ul>
                <p className="mb-2"><strong>Technical Information:</strong></p>
                <ul>
                  <li>Device identifiers and system configurations</li>
                  <li>Network and connection information</li>
                  <li>Usage analytics and system performance metrics</li>
                </ul>
              </div>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                2. How We Use Your Information
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3">We use collected information to:</p>
                <ul>
                  <li>Provide 24/7 video monitoring and incident response services</li>
                  <li>Operate remote concierge and access management systems</li>
                  <li>Generate time-lapse videos and security reports</li>
                  <li>Maintain and improve our AI-powered security systems</li>
                  <li>Communicate about services, incidents, and system updates</li>
                  <li>Process payments and manage customer accounts</li>
                  <li>Comply with legal obligations and emergency response requirements</li>
                  <li>Analyze and improve our security solutions</li>
                </ul>
              </div>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                3. Information Sharing and Disclosure
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3">We may share your information in the following circumstances:</p>
                <ul>
                  <li><strong>Emergency Response:</strong> With law enforcement, emergency services, or authorized personnel during security incidents</li>
                  <li><strong>Service Providers:</strong> With trusted third-party vendors who assist in providing our services</li>
                  <li><strong>Legal Compliance:</strong> When required by law, court order, or government request</li>
                  <li><strong>Business Operations:</strong> With property managers, building owners, or authorized representatives as specified in service agreements</li>
                  <li><strong>Consent:</strong> With your explicit permission for specific purposes</li>
                </ul>
                <p className="mt-3">
                  We never sell personal information to third parties and maintain strict confidentiality agreements with all service providers.
                </p>
              </div>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                4. Data Security and Retention
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3">We implement comprehensive security measures including:</p>
                <ul className="mb-3">
                  <li>End-to-end encryption for all video transmissions</li>
                  <li>Secure cloud storage with multi-factor authentication</li>
                  <li>Regular security audits and system monitoring</li>
                  <li>Access controls and employee training programs</li>
                </ul>
                <p className="mb-3">
                  <strong>Data Retention:</strong> We retain security footage and related data according to:
                </p>
                <ul>
                  <li>Standard retention: 30-90 days for routine surveillance footage</li>
                  <li>Incident-related data: Up to 7 years or as required by law</li>
                  <li>Account information: Duration of service agreement plus 3 years</li>
                  <li>Legal requirements: As mandated by applicable regulations</li>
                </ul>
              </div>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                5. Your Rights and Choices
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3">You have the right to:</p>
                <ul>
                  <li>Access and review your personal information</li>
                  <li>Request corrections to inaccurate data</li>
                  <li>Request deletion of personal information (subject to legal and contractual obligations)</li>
                  <li>Opt-out of non-essential communications</li>
                  <li>Request data portability for certain information</li>
                  <li>File complaints with relevant data protection authorities</li>
                </ul>
                <p className="mt-3">
                  To exercise these rights, contact us at legal@sterlingprotection.com or +1 (403) 992-1672.
                </p>
              </div>
            </section>

            <section className="mb-5">
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                6. Cookies and Tracking
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3">
                  Our website and systems use cookies and similar technologies to enhance functionality, analyze usage, and improve services. You can control cookie preferences through your browser settings.
                </p>
              </div>
            </section>

            <section>
              <h3 className="fw-bold mb-3" style={{ color: 'var(--accent-cyan)' }}>
                7. Contact Information
              </h3>
              <div style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>
                <p className="mb-3">
                  For questions about this Privacy Policy or our data practices:
                </p>
                <p className="mb-1"><strong>Sterling Surveillance Technologies LTD</strong></p>
                <p className="mb-1">Email: info@sterlingtechnologies.ca</p>
                <p className="mb-1">Phone: +1 (403) 992-1672</p>
                <p>Address: 123 Security Boulevard, Suite 100, Security City, SC 12345</p>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  </section>
  </div>
    );
  }
}

export default Privacy;